<template lang="html">
  <d-select v-model="selected">
    <option value="" selected disabled>{{ label }}</option>
    <option :value="option.value" v-for="(option, index) in options" :key="index">{{ option.text }}</option>
  </d-select>
</template>

<script>
export default {
  name: 'select-filter',
  props: {
    options: {
      type: Array,
    },
    model: {
      type: [Object, String, Number],
    },
    label: {
      type: String,
      default: 'Selecione uma opção',
    },
  },
  computed: {
    selected: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      },
    },
  },
};
</script>
